

























































































































































import Vue from 'vue';

import {
  upload,
  uploadUnsplashImage,
  uploadCanvaImageUrl,
  uploadPublicUrlImage,
  urlToFile,
  uploadFileToS3,
} from '@/web/services/upload';
import mediaApi from '@/core/api/modules/media-libraries';
import HMUnsplashImageSelectModal from '@/web/components/common/HMUnsplashImageSelectModal.vue';
import { getCanvaButtonApi } from '@/web/services/canva';
import { getConfig } from '@/web/utils/configuration';
import CropImageFormModal from '@/web/components/media-library/CropImageFormModal';
import HMEmbedImageModal from '@/web/components/common/HMEmbedImageModal.vue';

enum photoType {
  cover = 'cover',
  contain = 'contain',
  profile = 'profile',
}

export default Vue.extend({
  name: 'HMS3ImageUploader',
  props: {
    value: {
      type: [Object, String],
      default: null,
    },
    inputName: {
      type: String,
      default: 's3-upload',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    imageDescription: {
      type: String,
      default: '',
    },
    photoType: {
      type: String as () => photoType,
      default: 'cover',
    },
    canvaDesignType: {
      type: String,
      default: 'BlogBanner',
    },
    canvaWidth: {
      type: Number,
      default: 1920,
    },
    canvaHeight: {
      type: Number,
      default: 1080,
    },
    type: {
      type: String,
      default: 'normal',
    },
    cropper: {
      type: Boolean,
      default: true,
    },
    isUnsplashEnabled: {
      type: Boolean,
      default: true,
    },
    isCanvaEnabled: {
      type: Boolean,
      default: true,
    },
    isPCUploadEnabled: {
      type: Boolean,
      default: true,
    },
    embedImageEnabled: {
      type: Boolean,
      default: true,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: null,
      error: null,
      isUploading: false,
      showDropdown: false,
      isDragging: false,
      reader: new FileReader(),
    };
  },
  computed: {
    status() {
      if (this.isDragging) {
        return 'dragging';
      } else if (this.isUploading) {
        return 'uploading';
      } else if (this.value || this.src) {
        return 'uploaded';
      } else {
        return 'add';
      }
    },
    src() {
      if (typeof this.value === 'string') {
        return this.value;
      }
      return (
        this.value?.storage_url ||
        this.value?.embedded_image_url ||
        this.value?.thumbnail
      );
    },
    api() {
      return {
        upload,
        uploadUnsplashImage,
        uploadCanvaImageUrl,
        uploadPublicUrlImage,
        uploadFileToS3,
        remove: () => null,
      };
    },
    imageName() {
      if (this.value) {
        const splitedURL = this.value.split('/');
        if (splitedURL.length > 0) {
          const url = splitedURL[splitedURL.length - 1];
          const urlWithoutParams = this.value.split('?');
          return urlWithoutParams[0];
        }
      }
      return null;
    },
  },
  methods: {
    openCropImageModal(file) {
      if (!this.cropper) {
        return this.updateFile(file);
      }
      this.$modal.show(
        CropImageFormModal,
        {
          round: this.round,
          canvaWidth: this.canvaWidth,
          canvaHeight: this.canvaHeight,
          file,
          confirm: this.onCropConfirm,
        },
        {
          clickToClose: false,
          classes: ['vm--inline-modal'],
        }
      );
    },
    async onCropConfirm(croppedFile) {
      const file = await this.loadFile(croppedFile, false);
      this.updateFile(file);
    },
    async loadFile(inputFile) {
      if (!inputFile) return;
      this.isUploading = true;
      const file = await this.api.uploadFileToS3(inputFile);
      this.isUploading = false;
      return file;
    },
    async onFile(inputFile) {
      if (!inputFile) return;
      this.isUploading = true;
      this.reader.readAsDataURL(inputFile);
      this.reader.onloadend = async evt => {
        if (evt.target.readyState == 2) {
          const file = {
            storage_url: evt.target.result,
          };
          if (this.cropper) {
            this.openCropImageModal(file);
            this.isUploading = false;
            return file;
          } else {
            const localFile = await this.loadFile(inputFile);
            this.updateFile(localFile);
          }
        }
      };
    },
    onChange(e) {
      const file = e.target.files[0];
      this.$refs.inputFile.value = null;
      this.onFile(file);
    },
    drop: function (event) {
      event.stopPropagation();
      event.preventDefault();
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.onFile(file);
    },
    updateFile(file) {
      this.$emit('input', file);
    },
    dragging() {
      this.isDragging = true;
    },
    draggingStop() {
      this.isDragging = false;
    },
    async remove() {
      this.isUploading = true;
      const file = await this.api.remove();
      this.$emit('input', file);
      this.isUploading = false;
    },
    openEmbedImageModal() {
      this.$modal.show(
        HMEmbedImageModal,
        {},
        {},
        {
          selectImageUrl: this.onSelectEmbedImage,
        }
      );
    },
    openUnsplashModal() {
      this.$modal.show(
        HMUnsplashImageSelectModal,
        {
          onSelect: this.onSelectUnsplashImage,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    transformImageUrlParams(value) {
      return typeof value === 'string' ? value : value?.urls?.regular;
    },
    async onSelectUnsplashImage(selectedUnsplashImage) {
      this.isUploading = true;
      const file = this.transformImageUrlParams(selectedUnsplashImage);
      this.openCropImageModal(file);
      this.isUploading = false;
    },
    onSelectEmbedImage(selectedEmbedImage) {
      this.isUploading = true;
      this.openCropImageModal(selectedEmbedImage);
      this.isUploading = false;
    },
    openCanva() {
      let dimensions = {};
      if (this.canvaWidth && this.canvaHeight) {
        dimensions = {
          width: this.canvaWidth,
          height: this.canvaHeight,
        };
      }
      getCanvaButtonApi().createDesign({
        design: {
          type: this.canvaDesignType,
          dimensions: dimensions,
        },
        editor: {
          publishLabel: this.$t('GENERAL.LABEL.CANVA_SAVE_LABEL', {
            applicationName: getConfig().applicationName,
          }),
        },
        onDesignOpen: () => {
          // Triggered when editor finishes loading and opens a new design.
          // You can save designId for future use.
          console.log('Canva designer opened');
        },
        onDesignPublish: ({ exportUrl }) => {
          // Triggered when design is published to an image.
          // Save the image to your server as the exportUrl will expire shortly.
          console.log('Canva design published. Image url=', exportUrl);
          this.uploadCanvaImageUrl(exportUrl);
        },
        onDesignClose: () => {
          // Triggered when editor is closed.
          console.log('Canva designer closed');
        },
      });
    },
    async uploadCanvaImageUrl(imageUrl) {
      const file = await urlToFile(imageUrl);
      await this.onFile(file);
    },
  },
});
